import { IAppState } from '../../../AppModulesWrapper';

export const selectIsCalltrackingEnabled = (state: IAppState): boolean => {
  return state.servicePickerWidget.calltracking.isEnabled;
};
